import axios, { AxiosRequestConfig } from 'axios';
import { getClientId } from 'utils/client-id';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:3010/' });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem('serviceToken');
    if (!config.headers['Authorization'] && accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }

    config.headers['X-Client-Id'] = getClientId();

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const currentPath = window.location.pathname;
      const isAuthPage = currentPath.includes('/login') || currentPath.includes('/auth') || currentPath.includes('/verify');

      if (!isAuthPage) {
        // Save current URL for redirect after login
        const fullPath = window.location.pathname + window.location.search;
        sessionStorage.setItem('returnUrl', fullPath);

        // Clear authentication data
        localStorage.removeItem('serviceToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('role');
        localStorage.removeItem('waiterId');
        localStorage.removeItem('restaurant_ids');

        // Redirect to login page
        window.location.href = '/auth/login';
        return Promise.reject(error);
      }
    }
    // Preserve status code in the rejected data for error handling
    const errorData = error.response?.data || {};
    if (error.response?.status) {
      errorData._status = error.response.status;
    }
    return Promise.reject(errorData || 'Algo salió mal');
  }
);

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig]) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};
